<template>
  <section class="modal">
    <div class="box" style="font-family:'Draft B';">
      <div class="header">
        <transition name="title">
          <div class="title">Forma de Pagamento</div>
        </transition>
        <div @click="closeModal()" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div style="margin-left: 10px;">
        <div>
        <div v-if="loading" key="loading"><i class="fas fa-spinner loading-big"></i></div>
        <div v-if="!loading">
          <div class="show-payment-types">
            <!-- <div @click="type = 'savedCard'" class="show-payment-type payment-card" :class="{ active : type === 'savedCard'}">
              <i v-if="hasCreditCard.type === 'visa'" class="fab fa-cc-visa"></i>
              <i v-else-if="hasCreditCard.type === 'mastercard'" class="fab fa-cc-mastercard"></i>
              <i v-else-if="hasCreditCard.type === 'amex'" class="fab fa-cc-amex"></i>
              <i v-else-if="hasCreditCard.type === 'diners'" class="fab fa-cc-diners-club"></i>
              <i v-else-if="hasCreditCard.type === 'elo'" class="fas fa-credit-card"></i>
              <i v-else-if="hasCreditCard.type === 'hipercard'" class="fas fa-hipercard-card"></i>
              <i v-else-if="hasCreditCard.type === 'discover'" class="fas fa-discover-card"></i>
              <i v-else class="far fa-credit-card"></i>
              <div>XXXXXX XXXXXX XX{{ hasCreditCard.mask }}</div>
              <div>{{ hasCreditCard.name }}</div>
            </div> -->
          <!-- <div @click="selectPayment('credit')" class="show-payment-type" :class="{ active : type === 'credit'}">
            <i class="fas fa-credit-card"></i> Cartão de Crédito
          </div> -->
          <div @click="selectPayment('pix')" class="show-payment-type" :class="{ active : type === 'pix'}">
            <div class="pix">
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="35px" height="35px" baseProfile="basic"><path fill="#4db6ac" d="M11.9,12h-0.68l8.04-8.04c2.62-2.61,6.86-2.61,9.48,0L36.78,12H36.1c-1.6,0-3.11,0.62-4.24,1.76 l-6.8,6.77c-0.59,0.59-1.53,0.59-2.12,0l-6.8-6.77C15.01,12.62,13.5,12,11.9,12z"/><path fill="#4db6ac" d="M36.1,36h0.68l-8.04,8.04c-2.62,2.61-6.86,2.61-9.48,0L11.22,36h0.68c1.6,0,3.11-0.62,4.24-1.76 l6.8-6.77c0.59-0.59,1.53-0.59,2.12,0l6.8,6.77C32.99,35.38,34.5,36,36.1,36z"/><path fill="#4db6ac" d="M44.04,28.74L38.78,34H36.1c-1.07,0-2.07-0.42-2.83-1.17l-6.8-6.78c-1.36-1.36-3.58-1.36-4.94,0 l-6.8,6.78C13.97,33.58,12.97,34,11.9,34H9.22l-5.26-5.26c-2.61-2.62-2.61-6.86,0-9.48L9.22,14h2.68c1.07,0,2.07,0.42,2.83,1.17 l6.8,6.78c0.68,0.68,1.58,1.02,2.47,1.02s1.79-0.34,2.47-1.02l6.8-6.78C34.03,14.42,35.03,14,36.1,14h2.68l5.26,5.26 C46.65,21.88,46.65,26.12,44.04,28.74z"/></svg>
              <div style="margin-top:-5px;">Pix</div>
            </div>
          </div>
        </div>
        <div v-if="selectedType === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-line" style="margin: 0 -10px">
            <div class="payment-type">
              <i class="fab fa-cc-visa" style="color: #192061"></i> Visa
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-mastercard" style="color: #e35205"></i> Mastercard
            </div>
            <div class="payment-type">
              <i class="far fa-credit-card" style="color: #b82126"></i> Hipercard
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-amex" style="color: #27aee3 "></i> American Express
            </div>
            <!-- <div class="payment-type">
              <i class="fab fa-cc-diners-club" style="color: #2196f3"></i> Diners Club
            </div> -->
            <div class="payment-type">
              <i class="fas fa-credit-card" style="color: black"></i> Elo
            </div>
          </div>
        </div>
        <div v-if="selectedType === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc; padding-bottom: 30px">
          <div class="show-payment-form-break" style="width: 100%">
            <label style="color:#302e2e">Parcelamento</label>
            <select v-model="installment" style="width: 300px">
              <option v-for="i in installments" :key="i.installment" :value="i.installment">
                {{ `${i.installment} x R$ ${i.value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
                <span v-if="i.installment > 1">(R$ {{ (i.value * i.installment).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} com juros)</span>
              </option>
            </select>
          </div>
        </div>

        <div v-if="selectedType === 'credit' && installment" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-form-break">
            <label style="color:#302e2e">Número do cartão</label>
            <input v-model="creditNumber" v-mask="'#### #### #### ####'" placeholder="____ ____ ____ ____" type="text" style="width: 200px" :class="{ error : error.indexOf('creditNumber') > -1 }" id="cardNumber" />
            <div v-if="error.indexOf('creditNumber') > -1" class="hint">número de cartão inválido</div>
            <label style="color:#302e2e">Nome no cartão</label>
            <input v-model="creditName" type="text" :class="{ error : error.indexOf('creditName') > -1 }" id="owner" style="text-transform: uppercase;width: 200px"/>
            <div v-if="error.indexOf('creditName') > -1" class="hint">nome no cartão inválido</div>
          </div>
          <div class="show-payment-form-break" style="padding-left: 7px;">
            <label style="color:#302e2e">Validade do cartão</label>
            <input v-model="creditValidity" v-mask="'## / ##'" placeholder="xx / xx" type="text" :class="{ error : error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1 }" style="width: 100px" id="expiration-date" />
            <div v-if="error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1" class="hint">Validade incorreta MM/AA</div>
            <label style="color:#302e2e">Código de Segurança</label>
            <input v-model="creditCVV" v-mask="'###'" placeholder="xxx" type="text" :class="{ error : error.indexOf('creditCVV') > -1 }" style="width: 100px" id="cvv" />
            <div v-if="error.indexOf('creditCVV') > -1" class="hint">código de segurança inválido</div>
          </div>
          <!--<div class="show-payment-form-break">
            <label class="switch">
              <input v-model="saveCard" type="checkbox">
              <span class="slider"></span>
              <span class="text">Salvar cartão?</span>
            </label>
          </div> -->
        </div>
        <div v-if="selectedType === 'pix' && this.printUrl !== null" class="printable">
          <div>
            <div class="print-text" style="font-size: 12pt;font-family:'Draft B';padding: 0 15px;">Após realizar o pagamento, clique no botão <strong>Confirmar Pagamento</strong> para liberar sua assinatura ou aguarde cerca de 10min</div>
            <br>
            <div class="print-qrcode">
              <img :src="`${API}/barcode/qrcode/${printUrl}`" />
              <br>
              <p style="font-size:10pt;font-weight:bold;">Clique na Chave PIX para copiá-la</p>
              <br>
              <div @click="copyClipboard" style="padding-bottom: 10px;font-weight: 600;max-width:300px;word-wrap: break-word;margin:0 auto;">{{ printUrl }}</div>
              <font-awesome-icon icon="fa-regular fa-copy" class="copy-icon" style="font-size:16px;"/>
            </div>
            <br>
          </div>
          <div style="text-align:center;margin-top:-10px;font-size: 12pt;">
            <button @click="checkPix" class="button-save"><span>Confirmar Pagamento</span></button>
          </div>
          <!-- <div class="print-space"></div>
          <div class="print-text">{{ business.nameReal }}</div>
          <div class="print-text">{{ business.regDocument }}</div>
          <div class="print-text">{{ business.addressStreet }}, {{ business.addressNumber }}</div>
          <div class="print-text">{{ business.addressCity }} - {{ business.addressState }} - {{ business.addressPostcode }}</div> -->
        </div>
      </div>
    </div>
        <!-- <div>
          <div class="print-text" style="font-size: 12pt;font-family:'Draft B';padding: 0 15px;">Após realizar o pagamento, clique no botão <strong>Confirmar Pagamento</strong> para liberar sua assinatura ou aguarde cerca de 10min</div>
          <br>
          <div class="print-qrcode">
            <img :src="`${API}/barcode/qrcode/${ticket.printUrl}`" />
            <br>
            <p style="font-size:10pt;font-weight:bold;">Clique na Chave PIX para copiá-la</p>
            <br>
            <div @click="copyClipboard" style="padding-bottom: 10px;font-weight: 600;max-width:300px;word-wrap: break-word;margin:0 auto;">{{ ticket.printUrl }}</div>
            <font-awesome-icon icon="fa-regular fa-copy" class="copy-icon" style="font-size:16px;"/>
          </div>
          <br>
        </div> -->
        <div v-if="type && !selectedType" style="text-align:center;margin-top:15px;font-size: 12pt;">
          <button @click="checkPayment()" class="button-save"><span>Continuar</span></button>
        </div>
        <div v-if="selectedType === 'credit'" style="text-align:center;margin-top:15px;font-size: 12pt;">
          <button @click="finishPayment()" class="button-save"><span>Finalizar Pagamento</span></button>
        </div>
     </div>
    </div>
  </section>
</template>
<!-- <template>
  <section class="modal">
    <div class="show-payment">
    <div @click="setStep(4)" class="show-payment-toggle">
      <div>Forma de pagamento:</div>
      <div v-if="step > 4">{{ paymentTypeText }}</div>
      <i v-if="step > 4" class="fas fa-angle-down"></i>
    </div>
    <transition name="pop" mode="out-in">
      <div v-if="step === 4 && loading" key="loading"><i class="fas fa-spinner loading-big"></i></div>
      <div v-if="step === 4 && !loading" key="payment">
        <div class="show-payment-types">
          <div @click="type = 'savedCard'" v-if="hasCreditCard.name && showPayment.types.includes('credit')" class="show-payment-type payment-card" :class="{ active : type === 'savedCard'}">
            <i v-if="hasCreditCard.type === 'visa'" class="fab fa-cc-visa"></i>
            <i v-else-if="hasCreditCard.type === 'mastercard'" class="fab fa-cc-mastercard"></i>
            <i v-else-if="hasCreditCard.type === 'amex'" class="fab fa-cc-amex"></i>
            <i v-else-if="hasCreditCard.type === 'diners'" class="fab fa-cc-diners-club"></i>
            <i v-else-if="hasCreditCard.type === 'elo'" class="fas fa-credit-card"></i>
            <i v-else-if="hasCreditCard.type === 'hipercard'" class="fas fa-hipercard-card"></i>
            <i v-else-if="hasCreditCard.type === 'discover'" class="fas fa-discover-card"></i>
            <i v-else class="far fa-credit-card"></i>
            <div>XXXXXX XXXXXX XX{{ hasCreditCard.mask }}</div>
            <div>{{ hasCreditCard.name }}</div>
          </div>
          <div @click="type = 'credit'" v-if="showPayment.types.includes('credit')" class="show-payment-type" :class="{ active : type === 'credit'}">
            <i class="fas fa-credit-card"></i> {{ hasCreditCard.name ? 'Outro Cartão' : 'Cartão de Crédito' }}
          </div>
          <div @click="type = 'billet'" v-if="showPayment.types.includes('billet')" class="show-payment-type" :class="{ active : type === 'billet'}">
            <i class="fas fa-barcode"></i> Boleto
          </div>
          <div @click="type = 'pix'" v-if="showPayment.types.includes('pix')" class="show-payment-type" :class="{ active : type === 'pix'}">
            <font-awesome-icon icon="fa-brands fa-pix" /> Pix
          </div>
        </div>
        <form @submit.prevent v-if="type === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-line" style="margin: 0 -10px">
            <div class="payment-type">
              <i class="fab fa-cc-visa" style="color: #192061"></i> Visa
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-mastercard" style="color: #e35205"></i> Mastercard
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-amex" style="color: #27aee3 "></i> American Express
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-diners-club" style="color: #2196f3"></i> Diners Club
            </div>
            <div class="payment-type">
              <i class="fas fa-credit-card" style="color: black"></i> Elo
            </div>
            <div class="payment-type">
              <i class="far fa-credit-card" style="color: #b82126"></i> Hipercard
            </div>
          </div>
        </form>
        <form v-show="installments.length > 1 && (type === 'credit' || type === 'savedCard')" @submit.prevent class="form show-payment-form" style="border-bottom: 1px dashed #ccc; padding-bottom: 30px">
          <div class="show-payment-form-break" style="width: 100%">
            <label>Parcelamento</label>
            <select v-model="installment" style="width: 300px">
              <option v-for="i in installments" :key="i.installment" :value="i.installment">
                {{ `${i.installment} x R$ ${i.value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
                <span v-if="i.installment > 1">(R$ {{ (i.value * i.installment).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} com juros)</span>
              </option>
            </select>
          </div>
        </form>

        <form @submit.prevent v-if="type === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-form-break">
            <label>Número do cartão</label>
            <input v-model="creditNumber" v-mask="'#### #### #### ####'" placeholder="____ ____ ____ ____" type="text" :class="{ error : error.indexOf('creditNumber') > -1 }" style="width: 180px" id="cardNumber" />
            <div v-if="error.indexOf('creditNumber') > -1" class="hint">número de cartão inválido</div>
            <label>Nome no cartão</label>
            <input v-model="creditName" type="text" :class="{ error : error.indexOf('creditName') > -1 }" id="owner" style="text-transform: uppercase" />
            <div v-if="error.indexOf('creditName') > -1" class="hint">nome no cartão inválido</div>
          </div>
          <div class="show-payment-form-break">
            <label>Validade do cartão</label>
            <input v-model="creditValidity" v-mask="'## / ##'" placeholder="xx / xx" type="text" :class="{ error : error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1 }" style="width: 100px" id="expiration-date" />
            <div v-if="error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1" class="hint">Validade incorreta MM/AA</div>
            <label>Código de Segurança</label>
            <input v-model="creditCVV" v-mask="'###'" placeholder="xxx" type="text" :class="{ error : error.indexOf('creditCVV') > -1 }" style="width: 100px" id="cvv" />
            <div v-if="error.indexOf('creditCVV') > -1" class="hint">código de segurança inválido</div>
          </div>
          <div class="show-payment-form-break">
            <label class="switch">
              <input v-model="saveCard" type="checkbox">
              <span class="slider"></span>
              <span class="text">Salvar cartão?</span>
            </label>
          </div>
        </form>

        <form @submit.prevent class="form show-billet-form">
          <div class="show-billet-form-break">
            <label>CPF</label>
            <input v-model="document" v-mask="'###.###.###-##'" placeholder="___.___.___-__" type="text" :class="{ error : error.indexOf('document') > -1 || error.indexOf('registry_code') > -1 }" style="width: 180px" />
            <div v-if="error.indexOf('document') > -1 || error.indexOf('registry_code') > -1" class="hint">CPF inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>CEP</label>
            <div style="display: flex; align-items: center">
              <input v-model="addressPostcode" @input="typePostcode" v-mask="'#####-###'" placeholder="_____-___" type="text" :class="{ error : error.indexOf('addressPostcode') > -1 }" style="width: 180px" />
              <div v-if="loadingPostcode" style="margin-left: 10px"><i class="fas fa-spinner loading"></i></div>
            </div>
            <div v-if="error.indexOf('addressPostcode') > -1" class="hint">CEP inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Cidade</label>
            <div style="display: flex">
              <input v-model="addressCity" placeholder="Ex: São Paulo" type="text" :class="{ error : error.indexOf('addressCity') > -1 }" style="flex-grow: 1" />
              <select v-model="addressState" type="text" :class="{ error : error.indexOf('addressState') > -1 }" style="width: 60px; margin-left: 10px">
                <option :value="null">-</option>
                <option v-for="state in states" :key="state" :value="state">{{ state }}</option>
              </select>
            </div>
            <div v-if="error.indexOf('addressCity') > -1" class="hint">Cidade inválida</div>
            <div v-if="error.indexOf('addressState') > -1" class="hint">UF inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Bairro</label>
            <input v-model="addressSuburb" placeholder="Ex: Morumbi" type="text" :class="{ error : error.indexOf('addressSuburb') > -1 }" />
            <div v-if="error.indexOf('addressSuburb') > -1" class="hint">Bairro inválido</div>
          </div>
          <div class="show-billet-form-break" style="width: 100%">
            <label>Endereço</label>
            <input v-model="addressStreet" placeholder="Rua, Avenida, ..." type="text" :class="{ error : error.indexOf('addressStreet') > -1 }" />
            <div v-if="error.indexOf('addressCity') > -1" class="hint">Endereço inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Número</label>
            <input v-model="addressNumber" placeholder="Ex: 1234" type="text" :class="{ error : error.indexOf('addressNumber') > -1 }" style="width: 180px" />
            <div v-if="error.indexOf('addressNumber') > -1" class="hint">Número inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Complemento</label>
            <input v-model="addressAdjunct" placeholder="bl, apto, ..." type="text" :class="{ error : error.indexOf('addressAdjunct') > -1 }" style="width: 180px" />
          </div>
          <div class="show-payment-line" style="margin-top: 20px; margin-left: 10px">
            <button @click="selectPayment()" type="button" class="button-next"><span>Continuar</span><i class="fas fa-angle-right"></i></button>
          </div>
        </form>
      </div>
    </transition>
  </div>
  </section>
  </template> -->

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getFromCEP } from '../api/address'
import { payment, paymentCard } from '../api/signature'
import { checkPix } from '../api/ticket'

export default {
  name: 'Payment',
  props: ['product', 'signId', 'closeModal'],
  data () {
    return {
      API: process.env.VUE_APP_API,
      loading: false,
      type: null,
      error: [],
      selectedType: null,
      printUrl: null,
      hasCreditCard: {
        name: null,
        type: null,
        mask: null
      },
      creditNumber: null,
      creditValidity: null,
      creditName: null,
      creditCVV: null,
      document: null,
      addressPostcode: null,
      addressState: null,
      addressCity: null,
      addressSuburb: null,
      addressStreet: null,
      addressNumber: null,
      addressAdjunct: null,
      loadingPostcode: false,
      saveCard: false,
      installment: 1,
      installmentsItens: [
        {
          installment: 1,
          fee: 0,
          value: null
        },
        {
          installment: 2,
          fee: 7.64,
          value: null
        },
        {
          installment: 3,
          fee: 9.23,
          value: null
        },
        {
          installment: 4,
          fee: 10.86,
          value: null
        },
        {
          installment: 5,
          fee: 12.31,
          value: null
        },
        {
          installment: 6,
          fee: 13.65,
          value: null
        },
        {
          installment: 7,
          fee: 14.72,
          value: null
        },
        {
          installment: 8,
          fee: 16.23,
          value: null
        },
        {
          installment: 9,
          fee: 17.69,
          value: null
        },
        {
          installment: 10,
          fee: 18.65,
          value: null
        },
        {
          installment: 11,
          fee: 20.12,
          value: null
        },
        {
          installment: 12,
          fee: 21.61,
          value: null
        }
      ]
    }
  },
  computed: {
    ...mapState(['user']),
    /* paymentTypeText () {
      if (this.type === 'credit' || this.type === 'savedCard') return 'Cartão de Crédito'
      else if (this.type === 'pix') return 'Pix'
      else return 'Boleto'
    }, */
    installments () {
      console.log(this.product)
      return this.installmentsItens.map(x => {
        return {
          installment: x.installment,
          value: (this.product.price + ((this.product.price / 100) * x.fee)) / x.installment
        }
      })
    }
  },
  watch: {
    customer (customer) {
      if (customer) {
        this.loading = true
        this.hasCreditCard.name = customer.nameCard
        this.hasCreditCard.type = customer.typeCard
        this.hasCreditCard.mask = customer.maskCard
        if (this.hasCreditCard.name) {
          this.type = 'savedCard'
        } else {
          this.type = 'credit'
        }
        this.document = customer.document
        this.addressPostcode = customer.addressPostcode
        this.addressState = customer.addressState
        this.addressCity = customer.addressCity
        this.addressSuburb = customer.addressSuburb
        this.addressStreet = customer.addressStreet
        this.addressNumber = customer.addressNumber
        this.addressAdjunct = customer.addressAdjunct
        this.loading = false
      }
    },
    creditName (value) {
      this.creditName = value.replace(/[^a-zA-Z ]/g, '')
    }
  },
  methods: {
    copyClipboard () {
      const el = document.createElement('textarea')
      el.value = this.printUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$message.success('Chave PIX copiada!', { duration: 3000 })
    },
    async checkPix () {
      const response = await checkPix(this.printUrl)
      if (response && response.result === 'paid') {
        this.closeModal()
        this.$message.success('Assinatura ativada', { duration: 3000 })
        this.$router.push('/assinatura')
        setTimeout(() => {
          this.$router.go()
        }, 500)
      } else if (response && response.result === 'expired') {
        this.closeModal()
        this.$message.error('O PIX expirou, é preciso realizar nova compra', { duration: 3000 })
        this.$router.push('/usuario')
        setTimeout(() => {
          this.$router.go()
        }, 500)
      } else {
        this.$message.error('Pagamento PIX ainda não confirmado', { duration: 3000 })
      }
    },
    checkPayment () {
      console.log(this.type)
      if (this.type === 'credit') {
        this.selectedType = this.type
        this.printUrl = null
      } else {
        this.callPix(this.product)
      }
    },
    selectPayment (type) {
      console.log(type)
      this.type = type || this.type
      this.selectedType = null
    },
    async callPix (item) {
      // Parameters and options
      /* let message = 'Deseja gerar um PIX para pagar essa assinatura?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continuar',
        cancelText: 'Cancelar',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard', basic
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 0, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      } */

      this.$dialog.confirm('Deseja gerar um PIX para pagar essa assinatura?', {
        loader: true, // default: false - when set to true, the proceed button shows a loader when clicked.
        // And a dialog object will be passed to the then() callback
        okText: 'Continuar',
        cancelText: 'Cancelar'
      }).then(async dialog => {
        // Triggered when proceed button is clicked
        // dialog.loading(false) // stops the proceed button's loader
        // dialog.loading(true) // starts the proceed button's loader again
        // dialog.close() // stops the loader and close the dialog
        // do some stuff like ajax request.
        // console.log('Delete action completed ')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          console.log(item)
          /* if (item) {
            this.product = {
              name: item.name,
              id: item.id,
              price: item.price
            }
            // this.signId = item.id
          } else {
            this.signId = null
          } */
          const resultPix = await payment(this.signId, this.product.name, this.product.id, this.product.price)
          dialog.close()
          this.printUrl = resultPix
          this.selectedType = 'pix'
          console.log(this.printUrl)
          // this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          // this.product = null
          this.loading = false
        } catch (error) {
          dialog.close()
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      }).catch(() => {
        // Triggered when cancel button is clicked
        // console.log('Delete aborted')
      })
      // Trigger a confirmation dialog
      /* this.$dialog.confirm(message, options)
      .then(async function () {
        // This will be triggered when user clicks on proceed
        console.log('ok')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          if (item) {
            this.product = {
              name: item.name,
              id: item.product,
              price: item.price
            }
          }
          const resultPix = await payment(this.product.name, this.product.id, this.product.price)
          this.selectedWaiting = {
            printUrl: resultPix
          }
          this.product = null
          this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          this.loading = false
        } catch (error) {
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      })
      .catch(function () {
        // This will be triggered when user clicks on cancel
        // console.log('nok')
      }) */

      /* if (confirm('Deseja gerar um PIX para pagar essa assinatura?')) {
      } */
    },
    async finishPayment () {
      let payment = {
        type: this.type,
        document: this.document,
        addressPostcode: this.addressPostcode,
        addressState: this.addressState,
        addressCity: this.addressCity,
        addressSuburb: this.addressSuburb,
        addressStreet: this.addressStreet,
        addressNumber: this.addressNumber,
        addressAdjunct: this.addressAdjunct,
        saveCard: this.saveCard,
        installments: this.type === 'billet' ? 1 : this.installment
      }
      if (this.type === 'credit') {
        payment.creditNumber = this.creditNumber
        payment.creditValidity = this.creditValidity
        payment.creditName = this.creditName
        payment.creditCVV = this.creditCVV
      }
      // this.finishPayment(payment)
      try {
          if (this.loading) return false
          this.loading = true
          this.error = []
          let vality = String(this.creditValidity).replace('/', '')
          vality = String(vality).replaceAll(' ', '')
          const card = String(this.creditNumber).replaceAll(' ', '')
          const result = await paymentCard(this.signId,
          this.product.name,
          this.product.id,
          this.product.price,
          card,
          vality,
          this.creditName,
          this.creditCVV,
          this.installment
        )
          this.$analytics.event('bought', this.product.id)
          this.loading = false
          this.closeModal()
        } catch (error) {
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
            this.$message.error(data.error, { duration: 3000 })
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
    },
    async typePostcode (e) {
      try {
        // Search CEP
        if (e.data && this.addressPostcode.length === 9) {
          this.loadingPostcode = true
          const address = await getFromCEP(this.addressPostcode.replace('-', ''))
          this.addressState = address.state
          this.addressCity = address.city
          this.addressSuburb = address.suburb
          this.addressStreet = address.street
          this.loadingPostcode = false
        }
      } catch (error) {
        this.loadingPostcode = false
        logger.warn(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.pix {
  height:35px;
}
.modal .box {
    background-color: #f6f4f4;
}
.modal .close {
    color: #302e2e;
}
.modal .title {
    color: #302e2e;
}
.copy-icon {
  color: $primary-color;
  margin-left: 10px;
}

.top-btn {
  font-size: 9pt;
  font-weight: 400;
  margin: -20px 10px 20px 10px;
}
.btn-transfer {
  width: 120px !important;
  font-size: 10pt !important;
  font-weight: 400;
  margin:10px 0 20px 33%;
}
.btn-cancel {
  width: 190px !important;
  font-size: 10pt !important;
  font-weight: 400;
  margin:10px 0 20px 25%;
}
.cancel-text {
  text-align: center;
  font-size: 10pt !important;
}
.button-wallet {
  width: auto;
  height: 40px;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
  overflow-y: scroll;
}

.printable {
  font: 7pt sans-serif;
  line-height: 1.3;
  margin: 15px 0;
  padding: 0;
  color: #000000;
}

.print-text {
  text-align: center;
}

.print-space {
  height: 20px;
}

.print-qrcode {
  text-align: center;
  padding: 0 15px;
  img {
    display: block;
    max-width: 250px;
    height: auto;
    margin: 0 auto;
  }
}

.button-print {
  display: none;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .button-print {
    display: block;
  }
}

.show-payment {
  width: 100%;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
}

.show-payment-toggle {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 1em;
  font-weight: 300;
  div:nth-child(2) {
    color: $primary-color;
    font-size: 1.1em;
    font-weight: 500;
    margin-left: 10px;
  }
  i {
    flex: 1;
    text-align: right;
    cursor: pointer;
    font-size: 1.6em;
    color: #999;
  }
}

.show-payment-types {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 10px -5px;

  .show-payment-type {
    width: 180px;
    height: 100px;
    margin: 5px 5px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    font-size: 1em;
    color: $primary-color;
    padding: 10px 10px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: $hover-color-2;
    }
    &.active {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    }
    i, svg {
      width: 100%;
      font-size: 2em;
      margin: 10px 0;
    }
  }

  .payment-card {
    text-align: left;
    i {
      text-align: right;
      margin: 0;
    }
    div:nth-child(2) {
      font-size: 0.9em;
      margin: 15px 0 5px;
    }
    div:nth-child(3) {
      font-size: 0.8em;
      margin: 5px 0;
    }
  }
}

.show-payment-line {
  width: 100%;
  display: flex;
}

.payment-type {
  display: flex;
  align-items: center;
  color: #555;
  font-size: 0.8em;
  /*text-transform: uppercase;*/
  margin: 5px 10px;
  line-height: 19px;
  flex-wrap: wrap;
  i {
    font-size: 1.5em;
    margin-right: 5px;
  }
}

.show-payment-form {
  padding: 10px 0;
  label:first-child {
    margin-top: 20px;
  }
  font-size: 12px;
}

.show-payment-form-break {
  display: flex;
  flex-direction: column;
}

.show-billet-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 0;
  margin: 0 -10px;
}

.show-billet-form-break {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

@media screen and (min-width: $desktop-width) {

  .show-payment-form {
    flex-direction: row;
    flex-wrap: wrap;
    .show-payment-form-break {
      padding-right: 40px;
    }
  }

  .show-payment-form-break {
    width: 50%;
  }

  .show-payment-types {
    justify-content: center;
  }

  .show-billet-form-break {
    width: 50%;
  }

}
</style>
